import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
// import { isAuthorized } from "@/entities/User";
import { getCookie } from '@/plugins/cookie'
// import { fetchProfile } from "@/entities/Profile";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        // redirect: {
        // 	name: 'main',
        // },
        name: 'landing-page',
        component: () => import('@/views/LandingView.vue'),
    },
    // {
    // 	path: '/auth',
    // 	name: 'auth',
    // 	component: () => import('@/views/auth/AuthView.vue'),
    // },
    // {
    // 	path: '/register',
    // 	name: 'register',
    // 	component: () => import('@/views/registration/RegistrationView.vue'),
    // },
    // {
    //     path: '/event-registration/:id',
    //     name: 'event-registration',
    //     component: () => import('@/views/registration/EventRegistrationView.vue'),
    // },
    {
        path: '/main',
        name: 'main',
        component: () => import('@/views/MainPageView.vue'),
    },
    {
        path: '/policy',
        name: 'policy',
        component: () => import('@/views/PolicyView.vue'),
    },
    // {
    //     path: '/instruction',
    //     name: 'instruction',
    //     component: () => import('@/views/InstructionView.vue'),
    // },
    {
        path: '/education',
        redirect: {
            path: '/education/actual',
        },
        children: [
            {
                path: '/education/:type',
                name: 'education',
                component: () => import('@/views/EducationView.vue'),
            },
            {
                path: 'course',
                name: 'courses',
                children: [
                    {
                        path: ':id',
                        name: 'course',
                        component: () => import('@/views/SpecialCourseView.vue'),
                    },
                ],
            },
            {
                path: 'module',
                name: 'modules',
                children: [
                    {
                        path: ':id',
                        name: 'module',
                        component: () => import('@/views/ModuleView.vue'),
                    },
                    {
                        path: 'tests/:id',
                        name: 'module-tests',
                        component: () => import('@/views/test/TestView.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: '/company',
        name: 'company',
        children: [
            {
                path: ':id',
                name: 'company-name',
                component: () => import('@/views/SponsorView.vue'),
            },
        ],
    },
    {
        path: '/events',
        redirect: {
            path: '/events/all',
        },
        children: [
            {
                path: ':type',
                name: 'events',
                component: () => import('@/views/events/EventsView.vue'),
            },
            {
                path: ':type/:id',
                name: 'event',
                component: () => import('@/views/events/EventItem.vue'),
            },
            {
                path: 'public/:id',
                name: 'event-public',
                component: () => import('@/views/events/EventItem.vue'),
            },
        ],
    },
    {
        path: '/media',
        name: 'media',
        component: () => import('@/views/MediaView.vue'),
    },
    {
        path: '/podcasts',
        name: 'podcasts',
        component: () => import('@/views/PodcastsView.vue'),
    },
    {
        path: '/podcasts/:id',
        name: 'podcast',
        component: () => import('@/views/ModuleView.vue'),
    },
    {
        path: '/media/:id',
        name: 'article',
        component: () => import('@/views/ArticleView.vue'),
    },
    // {
    //     path: '/communities',
    //     redirect: {
    //         path: '/communities/all',
    //     },
    //     children: [
    //         {
    //             path: '/communities/:type',
    //             name: 'communities',
    //             component: () => import('@/views/communities/CommunitiesView.vue'),
    //         },
    //         {
    //             path: ':type/:id',
    //             name: 'community-publish',
    //             component: () => import('@/views/public/PublicView.vue'),
    //         },
    //     ],
    // },

    {
        path: '/medications',
        name: 'medications',
        component: () => import('@/views/medication/MedicationsView.vue'),
    },

    {
        path: '/medication/:id',
        name: 'medication',
        component: () => import('@/views/medication/MedicationView.vue'),
    },

    {
        path: '/personal',
        name: 'personal',
        component: () => import('@/views/personal/PersonalView.vue'),
    },

    // {
    //     path: '/for-lectors',
    //     name: 'for-lectors',
    //     component: () => import('@/views/static/LectorSignupView.vue'),
    // },
    {
        path: '/for-lectors',
        name: 'for-lectors',
        component: () => import('@/views/DoctorSignupView.vue'),
    },
    // {
    //     path: '/publish/:id',
    //     name: 'publish',
    //     component: () => import('@/views/public/PublicView.vue'),
    // },
    {
        path: '/favorites',
        redirect: {
            path: '/favorites/all',
        },
    },
    {
        path: '/favorites/:type',
        name: 'favorites',
        component: () => import('@/views/favorites/FavoritesView.vue')
    },
    {
        path: '/doc/:user_id',
        name: 'certificate',
        component: () => import('@/views/redirect/redirectToCertificate.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () => import('@/views/NotFoundView.vue')
    },
]

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth',
			}
		} else if (savedPosition) {
			return savedPosition
		} else {
			return {
				left: 0,
				top: 0,
				behavior: 'smooth',
			}
		}
	},
    history: createWebHistory(),
    routes
});

function reloadWithCacheHusting() {
	const reloadDate = parseInt(localStorage.getItem('reloadWithCacheHustingDay') ?? '0');
	const currentDate = parseInt((new Date().valueOf() / 1000).toString());

	if ((reloadDate - currentDate) <= 0 || Number.isNaN(reloadDate)) {
		localStorage.setItem('reloadWithCacheHustingDay', parseInt(
            ((new Date().valueOf() / 1000) + (60 * 60)).toString()
        ).toString());
        // @ts-ignore
		window.location.reload(true);
	}
}

// https://doc.doriclub.uz/auth?phone=00%20000%2000%2000&pin=4321

// await fetchProfile('my')

router.beforeEach(async (to, from, next) => {

	const login_phone = Object.keys(to?.query ?? {})?.find?.(q => q?.toLowerCase?.()?.includes?.('phone'));
	const login_pin = Object.keys(to?.query ?? {})?.find?.(q => q?.toLowerCase?.()?.includes?.('pin'));
	if (to.query?.[`${login_phone}`]) {
		localStorage.setItem('login_phone', to.query?.[`${login_phone}`] + '');
		localStorage.setItem('login_pin', (to.query?.[`${login_pin}`] ?? 4321) + '');
	}

	const utm_query_name = Object.keys(to?.query ?? {})?.find?.(q => q?.toLowerCase?.()?.includes?.('utm'));
	if (to.query?.[`${utm_query_name}`]) {
		localStorage.setItem('utm', to.query?.[`${utm_query_name}`] + '');
	}
	if (to.query?.invite_code) {
		localStorage.setItem('invite_code', to.query?.invite_code + '');
	}

    // @ts-ignore
	if (['policy', 'instruction', 'certificate', 'event-public']?.includes?.(to?.name) || (to.name === 'course' && to.params?.id == 1)) {
		reloadWithCacheHusting();
		next()
	} else if (
		to.name !== 'landing-page' &&
		!getCookie('accessToken') &&
		!getCookie('refreshToken')
	) {
		next({ name: 'landing-page', query: to.query })
	} else if (to.name === 'landing-page' && getCookie('accessToken') && getCookie('accessToken')) {
		next({ name: 'main', query: to.query })
	} else {
		reloadWithCacheHusting();
		next()
	}
    // if (to.name !== 'main' && isAuthorized.value == false) return { name: 'main' };
    // return true
})

export default router
